import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { AudioFileSearch } from '@videoblocks/react-icons';

import { legacyContentTypes as audioContentTypes } from '../../entities/AudioSearchFilterOptions';
import { selectShowSearchByAudioButton } from '../../selectors/searchSelectors';
import AudioFileSearchModal from '../modal/AudioFileSearchModal';

type SearchWithAudioButtonProps = {
  contentType: string;
};

const SearchWithAudioButton = ({ contentType }: SearchWithAudioButtonProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showButton = audioContentTypes
    .map(({ value }) => value)
    .includes(contentType);

  const showAudioButton = useSelector(selectShowSearchByAudioButton);

  if (!showButton || !showAudioButton) {
    return null;
  }

  return (
    <>
      <button
        onClick={() => setIsModalOpen(true)}
        className="hidden md:flex w-64 border-none whitespace-nowrap overflow-hidden justify-center py-6 bg-yellow-400 rounded-full hover:bg-yellow-500 "
      >
        <AudioFileSearch className="w-6 h-6 mr-2" />
        <span className="text-gray-900 font-semibold">
          Search with Audio Clip
        </span>
      </button>
      <AudioFileSearchModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};

export default SearchWithAudioButton;
